import ReservationVue from '@/views/sm/reservation/reservation.vue';

const basePath = '/sm/reservation';
const role = 'sm'; // 角色身份

export const SM_RESERVATION_INDEX = 'sm-reservation-index';
export const SM_RESERVATION_EDIT = 'sm-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReservationVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_RESERVATION_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation-index" */
        `@/views/${role}/reservation/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SM_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation-edit" */
        `@/views/${role}/reservation/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
